import {Select} from "antd";
import styled from "styled-components";

export const Container = styled.div`
    width: 100%;
    flex: 1;
`;
export const SelectField = styled(Select)`
    width: 100%;
`;
export const QuickReactionContainer = styled.div`
    margin-top: 10px;
`;

export const Title = styled.h4`
    margin-left: 10px;
`;

export const Row = styled.div`
    margin: 8px;
    background-color: red;
    flex-direction: row;
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
`;

export const TimeContainer = styled.div``;
